import { Link, useLocation } from "react-router-dom";
import { useSeo } from "@/hooks/useSeo";

export default function NotFound() {
  const location = useLocation();

  useSeo({
    title: "页面不存在 - 404 | 爆料平台",
    description: "你访问的页面不存在或已被移动，可以返回首页或浏览线索归档。",
    path: location.pathname,
  });

  return (
    <div className="flex min-h-[60vh] w-full flex-col items-center justify-center px-4 py-20 text-center">
      <span className="font-heading text-6xl font-bold text-primary-500 md:text-8xl">404</span>
      <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
        这个页面不存在
      </h1>
      <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
        你要找的内容可能已被移动或删除。可以回到首页，或者去线索归档里继续查找。
      </p>
      <p className="mt-2 text-xs text-foreground-400">{location.pathname}</p>
      <div className="mt-8 flex flex-col gap-3 sm:flex-row">
        <Link
          to="/"
          className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-label font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-5-line" />
          返回首页
        </Link>
        <Link
          to="/clues"
          className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-5 py-3 text-sm font-label font-medium text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-700"
        >
          <i className="ri-article-line" />
          浏览线索归档
        </Link>
      </div>
    </div>
  );
}